import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from 'src/app/providers/environment';
import { SearchResult } from 'src/app/types/search';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);
  private readonly authService = inject(AuthService);

  query(query: string) {
    return this.http.post<SearchResult[]>(
      this.env.server + '/search/' + (this.authService.isAdmin ? 'admin' : 'client'),
      {
        query,
      },
    );
  }
}
